module.exports = __webpack_public_path__ + "img/va.318a1d44.svg";